<template>
    <div>
        <div v-if="mode==1" :class="{clubactive: clubactive}">
            <div class="comp-nav-menu edit-menu-overlay is-fixed-top">
                <div class="comp-nav-item comp-nav-menu-header">
                    Add Competitors
                </div> 
                <a role="button" @click="clubactive=false;step=0;" class="comp-nav-burger burger is-active">
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                </a>
            </div>
            <div class="competitor-mask"></div>
            <div class="columns">
                <div class="column" v-if="step===0">
                    <div class="clubactivator" v-if="clubneeded">
                        <label class="label">Which Gym Club?</label>
                        <div class="field has-addons"> 
                            <b-autocomplete
                                :placeholder="clubplaceholder"
                                :data="clubs"
                                field="name"
                                :open-on-focus="true"
                                size="is-medium"
                                icon="magnify"
                                @click.native="clubplaceholder='Start Typing...'"
                                @focus="clubplaceholder='Start Typing...'"
                                @blur="clubplaceholder='Select a Club...'"
                                :loading="isFetchingClubs"
                                @typing="getAsyncClubs"
                                @select="option => setselectedclub(option)"
                            >
                            <!--<template slot-scope="props">
                                <div class="media">
                                    {{props.name}}
                                </div>
                            </template>-->
                            </b-autocomplete> 
                            <p class="control">
                                <button class="button is-medium new-two-line is-outlined">
                                    <b-icon icon="plus" size="is-medium" type="is-dark"></b-icon>
                                    <span class="ntl-text">New<br>Club</span>
                                </button>
                            </p>
                        </div>
                    </div>
                    <div class="for-club-shift">
                        <div class="for-club-label"  v-if="selectedclub">
                            Competitors for <strong>{{this.selectedclub.name}}</strong>
                        </div>
                        <!-- @keyup.enter.prevent="parsetext" @keyup.188.prevent="parsetext" -->
                        <b-field class="help-shift-x" message="One per line or separate with a comma">
                            <textarea ref="textarea" :disabled="selectedclub==null && clubneeded" @keyup.prevent="validatetext" class="textarea add-competitors" placeholder="ENTER NAMES HERE"></textarea>
                        </b-field>
                        <b-field>
                        <b-button @click="parsetext" v-if="textvalid" type="is-primary"  style="margin-right: 1.0rem;" >Submit</b-button>
                        <b-button @click="mode=0" type="">Cancel</b-button>
                        </b-field>
                    </div>
                </div>
                <div class="column">
                    <!--
                    <div v-if="newcompetitors.length && step===1" class="level tick-level">
                        <div class="level-item">
                            <span class="tick-label">Select: </span>
                            <a @click="checkallnewcompetitors" class="button" :disabled="newcompetitors.every(p => { return selectednewcompetitors.includes(p)})" >All</a>
                            <a @click="checknonenewcompetitors" class="button" :disabled="selectednewcompetitors.length===0">None</a>
                        </div>
                    </div>
                    -->
                    <div v-if="step===1" class="">
                        <b-field v-if="newcompetitors.length > 0">
                        <b-button @click="() => nextstep(-1)" type="is-light" class="is-small grey-but">Add More Competitors</b-button>
                        </b-field>
                        <div class="button-row">
                            <span class="select-text is-size-7">Select</span>
                            <b-button @click="checkallnewcompetitors" :disabled="selectednewcompetitors.length==newcompetitors.length" type="is-light" class="is-small grey-but">All</b-button>
                            <b-button @click="checknonenewcompetitors" :disabled="selectednewcompetitors.length==0" type="is-light" class="is-small grey-but">None</b-button>
                        </div>
                        <div class="newcompetitorscroll" :class="'is-step-'+step">
                            <label v-for="(nam, ind) in newcompetitors" class="newcompetitor-item" :key="ind+nam" :class="{complete:nam.classification && nam.ageClassification}">
                                <b-checkbox v-if="step > 0" class="nc-checkbox" v-model="selectednewcompetitors" :native-value="nam">
                                    <span class="nc-name">{{nam.competitor.name}}</span>
                                    <span class="nc-label">
                                        <span class="nc-club" v-if="nam.competitor.club">{{nam.competitor.club.shortName||nam.competitor.club.name}}</span>
                                        <span v-if="nam.classification && nam.ageClassification" class="nc-level">{{nam.classification.name}} - {{nam.ageClassification.name}}</span>
                                    </span>
                                </b-checkbox>
                                <span v-else class="nc-name">{{nam}}</span>
                            </label>
                        </div> 
                    </div>
                    <div v-if="step===1" class="action-header header-hint has-background-info" :class="{active: (selectednewcompetitors.length==0 && step==1)&&hideheaderhint==false}">
                        <div class="container">
                            <svg class="hint-arrow" xmlns="http://www.w3.org/2000/svg" width="34.412" height="41.6" viewBox="0 0 34.412 41.6"><g transform="translate(-41.654 -562)"><path d="M14357.613-620.8H14323.2l17.854,19.935Z" transform="translate(-14281.547 1204.465)" fill="#167df0"/><rect width="8.9" height="26.632" transform="translate(54.59 562)" fill="#167df0"/></g></svg>
                            <span class="action-text has-text-white">
                                Select people&nbsp;<strong>here</strong>
                            </span>
                            <b-button @click="hideheaderhint=true" type="is-info" class="action-close" icon-left="close"></b-button>
                        </div>
                    </div>
                    <div v-if="step===1" class="action-footer action-bar done-bar">
                        <b-button @click="addcompetitors" :class="{ 'is-primary': stepvalid, 'is-outlined is-inverted is-info': !stepvalid  }" :disabled="!stepvalid" type="is-primary is-large">Save Competitors</b-button>
                    </div>
                    <div v-if="step===1" class="action-footer action-bar" :class="{active: (selectednewcompetitors.length>0 && step==1)}">
                        <div class="action-hint has-background-info" :class="{hidehint:hidefooterhint==true}">
                            <svg class="hint-arrow" xmlns="http://www.w3.org/2000/svg" width="34.412" height="41.6" viewBox="0 0 34.412 41.6"><g transform="translate(-41.654 -562)"><path d="M14357.613-620.8H14323.2l17.854,19.935Z" transform="translate(-14281.547 1204.465)" fill="#167df0"/><rect width="8.9" height="26.632" transform="translate(54.59 562)" fill="#167df0"/></g></svg>
                            <span class="action-text has-text-white">
                                
                                Choose their level&nbsp;<strong>here</strong>
                            </span>
                            <b-button @click="hidefooterhint=true" type="is-info" class="action-close" icon-left="close"></b-button>
                        </div>
                        <b-button @click="levelModalActive=true" class="is-large" icon-right="unfold-more-horizontal">Select a Level </b-button>
                        <b-button @click="deletenewcompetitors" class=" on-right is-dark" icon-left="delete">Delete Selected</b-button>
                    </div>

                </div>
            </div>
        </div>
                <b-modal :active.sync="levelModalActive">
                    <div class="levelmodalmenu has-background-light">
                        <b-field>
                            <radio-menu @input="setcompetitors" 
                            label="Set Levels" :items="levelsandages" v-model="chosenlevel">

                            </radio-menu>
                        </b-field>
                    </div>
                </b-modal>
        <div v-if="mode==0">
            <b-field class="items-centre">
            <b-button @click="() => { step=0, mode=1 }" :type="{'is-lighter':competition.competitors.length, 'is-primary': competition.competitors.length==0}" class="grey-but" style="margin-right: 1rem;">Add <span v-if="competition.competitors.length">More </span>Competitors</b-button>
            <strong>{{competition.competitors.length}}</strong>&nbsp;Competitors
            </b-field>
            <b-field class="allow-reg">
                <b-checkbox @input="$emit('dosavechanges')" v-model="competition.allowCompetitorReg">Competitors submit their own scores</b-checkbox>
                <span class="help-dot" @click="helpregactive=true" ><i class="mdi mdi-help mdi-18px"></i></span>
            </b-field>
            <div class="competitorscroll" v-if="competition.competitors.length">
                <label v-for="(nam, ind) in filteredcompetitors" :class="{active: selectedcompetitors.includes(nam)}" class="newcompetitor-item" :key="ind+nam">
                    <b-checkbox class="c-checkbox" v-model="selectedcompetitors" :native-value="nam">
                        <zero-pad class="c-number" :value="nam.number" :length="4"></zero-pad>
                        <span class="c-name">{{nam.competitor.name}}</span>
                        <span class="c-club" v-if="nam.competitor.club">{{nam.competitor.club.shortName||nam.competitor.club.name}}</span>
                        <span v-if="nam.classification && nam.ageClassification" class="c-level">{{nam.classification.name}} - {{nam.ageClassification.name}}</span>
                    </b-checkbox>
                </label>
                <b-notification type="is-warning" aria-close-label="Close notification" role="alert" v-if="filteredcompetitors.length==0">
                    No competitors match the filter.
                    <br>
                    <br>
                    <b-button @click="resetfilters">Clear Filters</b-button>
                    
                </b-notification>
            </div> 

            <div class="action-footer action-bar edit-bar" :class="{active: (selectedcompetitors.length>0)}">
                <b-button @click="editCompetitorModalActive=true" type="is-primary" 
                class="is-large" icon-right="circle-edit-outline">Edit Selected </b-button>
                <b-button @click="deletecompetitors" 
                class=" on-right is-dark" icon-left="delete">Delete Selected</b-button>
            </div>

                <b-modal :active.sync="editCompetitorModalActive">
                    <div class="levelmodalmenu has-background-light">
                        <b-field>
                            <radio-menu @input="editcompetitors" 
                            label="Set Levels" :items="levelsandages" v-model="chosenlevel">

                            </radio-menu>
                        </b-field>
                    </div>
                </b-modal>
                <b-modal :active.sync="helpregactive" class="b-help-modal">
                    <div class="help-modal">
                        <div class="help-example">
                            <b-checkbox @input="$emit('dosavechanges')" v-model="competition.allowCompetitorReg">Competitors submit their own scores</b-checkbox>
                        </div> 
                        <p class="help-desc">
                        When ticked, the competitors can register online
                        and submit their own scores. Otherwise, you enter 
                        them <span class="help-anchor" 
                            @click="helpregactive=false;$emit('showscoretab')"
                        >here</span>
                        </p>
                        <b-field class="help-buttons"><b-button type="is-info" size="is-large" @click="helpregactive=false">Ok</b-button></b-field>
                    </div>
                </b-modal>

            <div  v-if="competition.competitors.length" class="action-bar filter-bar">
                <span class="filter-label">Filter:&nbsp;</span>
                <b-button v-if="clubsfilter.length > 1" @click="clubFilterActive=true" type="is-dark"  icon-right="unfold-more-horizontal">{{clubfilterlabel}}</b-button>
                <b-button @click="levelFilterActive=true" type="is-dark" icon-right="unfold-more-horizontal">{{selectedfilterlevels?selectedfilterlevels.class.name + ' - '+selectedfilterlevels.age.name:'All Levels'}}</b-button>
            </div>
            <b-modal :active.sync="clubFilterActive">
                <div class="levelmodalmenu has-background-light">
                    <b-field>
                        <radio-menu @input="filterbyclub" label="Filter by Club" 
                        :initial="{ label: 'All Clubs', value: 0 }"
                        :items="clubsfilter" v-model="selectedfilterclubs">

                        </radio-menu>
                    </b-field>
                </div>
            </b-modal>
            <b-modal :active.sync="levelFilterActive">
                <div class="levelmodalmenu has-background-light">
                    <b-field>
                        <radio-menu @input="filterbylevel" label="Filter by Level" 
                        :initial="{ label: 'All Levels', value: 0 }"
                        :items="levelsandages" v-model="selectedfilterlevels">

                        </radio-menu>
                    </b-field>
                </div>
            </b-modal>
        </div>
    </div>
</template>
<style>
.b-help-modal .modal-content { max-height: initial; }
.help-anchor { border-bottom: 1px solid blue; cursor:pointer; display: inline-block; color: blue; }
.help-dot:active { background-color: #333; color: #fff; }
.help-desc { padding: 2rem 0; }
.help-example { 
    background: #ebebeb; margin-left: -2rem;
    margin-top: -2rem;
    margin-right: -2rem;
    padding: 2rem 0 2rem 2rem;
    white-space: nowrap;
    overflow: hidden;
    pointer-events: none; 
    position: relative;
    border-bottom: 0.25rem solid #167df0;
}
.help-example::after { content: ''; position: absolute; right: 0; top: 0; bottom: 0; width: 6rem; background: linear-gradient(90deg, rgba(235,235,235,0) 00%, rgba(235,235,235,1) 100%); }
.help-modal { width: 75%; margin: 0 auto; max-width: 20rem; background: #fff; color: #000; padding: 2rem;  box-shadow: 0rem 0rem 0 0.5rem rgba(255, 255, 255, 0.2); }
.help-buttons { display: flex; justify-content: flex-end; }
body.ofh { height: 100vh; overflow: hidden; }
.for-club-label { padding: 1rem 0;}
textarea.add-competitors[disabled] { border-color: #ddd; }
.edit-menu-overlay { opacity:0; transition: all 0.4s; pointer-events: none; }
.clubactivator { transform: translateY(0); position:relative; z-index: 10; transition: all 0.4s; background-color: transparent ;margin-bottom: 1rem; }
.competitor-mask { position: absolute; opacity:0;  transition: all 0.4s; pointer-events: none; left: 0; right:0; top:0; height: 5rem; background-color: #f5f5f5; }
.clubactive .edit-menu-overlay { opacity: 1; transition: all 0.4s; pointer-events: all; }
.clubactive .competitor-mask { opacity: 1; transition: all 0.4s; }
.clubactive .clubactivator, .clubactive .for-club-shift {  transform: translateY(-3.25rem);  }
 .items-centre { align-items: center; }
.button.new-two-line { font-size: 0.75rem !important; height: 2.8rem !important;  }
.new-two-line i { opacity: 0.5; }
.new-two-line .icon { margin-left: 0rem !important; }
.ntl-text { display: inline-flex; margin-left: 0.35rem;; }
.comp-nav-menu-header { font-size: 1.5rem; }
.newcompetitorscroll { overflow:auto; }
.newcompetitorscroll.is-step-0 { height: calc(100vh - 24rem); }
.newcompetitorscroll.is-step-1 { height: calc(100vh - 14rem); }
.help-shift > .help { margin-top: -1.5rem; background: #ffffff; position: relative; 
left: 0.5rem; color: rgba(0, 0, 0, 0.5);
width: calc(100% - 1rem);
    height: 1.45rem;
 }
.bit-down-c {border-top: 1rem solid transparent;}
.newcompetitor-item { display: flex; position: relative; align-items: center; padding: 0.5rem; cursor: pointer; background: #fff; margin-bottom: 0.5rem; }
.newcompetitor-item.complete { background-color: #d2e8ca; }
.nc-name { flex-grow:1; text-transform: capitalize; }
.nc-label { display: flex; flex-direction: column; }
.nc-club, .nc-level { font-size: 0.75rem; }
.c-club, .c-level { font-size: 0.75rem; }
.c-checkbox { width: 100%; }
.c-checkbox .control-label { display: grid; 
    grid-template-columns: 3.5rem 2fr 1fr 1fr; width: 100%; 
}
.c-number{ text-align: center; }  
.nc-checkbox, .nc-checkbox .control-label { width: 100%; }
.nc-checkbox .control-label { display: flex; align-items: center; }
.edit-comp { padding: 0rem 0 6rem; }
.comp-footer { position: fixed; bottom: 0; left: 0; right: 0; color:#fff; background: #333; padding:1.5rem; }
textarea.add-competitors { padding-bottom: 1.5rem;}
.overlay-comp-nav {
    position: fixed; top:0;left:0; right:0; height: 3.25rem;
    background-color: #FFF; z-index: 40;
}
.filter-bar {
    bottom:0; background: #999;
    justify-content: center;
}
.filter-bar .button .icon:last-child:not(:first-child) { margin-left: auto; }
.filter-bar button { margin: 0 0.25rem; } 
.filter-bar button span { overflow: hidden; }
.filter-label { display: none; }
.action-bar.filter-bar {
    display: grid;
    grid-template-columns: 100%;
    row-gap: 0.5rem;
}
.action-bar { 
    display: flex;
    padding:1rem;
    left: 0;    position: fixed;
    right: 0;    z-index: 30; 
    transition: all 0.5s;
}
.header-hint {
    display: flex; 
    align-items: center;    left: 0;    position: fixed;
    right: 0;    z-index: 30; padding: 3.5rem 1.5rem 0;

}
.action-header { 
    position: fixed; top:0; z-index: 30;
    transition: all 0.5s;
    transform: translateY(-100%);
}
.action-header > .container { display: flex; }
.action-header.active {
    transition: all 0.5s;
    transform: translateY(0);
}
.action-footer { 
    bottom: 0;     background: #333;  transition: all 0.5s;
    transform: translateY(11rem);
}
.action-footer.done-bar { transform: translateY(0rem); }
.action-footer.active { transform: translateY(0%); transition: all 0.5s;}
.action-bar strong, .action-header strong { color:#fff;}
.action-header > .action-hint { position: relative;}
.action-close.button { margin-right: 0.5rem; border-radius: 100% !important; }
.action-text { display:flex; flex-grow: 1; padding:1rem 0rem; position: relative; }
.action-hint { position: absolute; top:0;   left: 0;    right: 0;    z-index: 30; transition: all 0.5s; opacity:1;
    display: flex; flex-grow: 1; align-items: center; transform: translateY(-100%); padding-top: 2.5rem; }
.action-hint.hidehint { opacity: 0; transition: all 0.5s; }
.hint-arrow { 
    height: 1.75rem;    top: 4.25rem;    position: absolute;
    left: 1rem; transition: all 0.5s;
     } 
.action-header .hint-arrow {
    top: 0rem;
    left: 0rem;
}
.action-footer.active .hint-arrow {
    top: 5.6rem;
}
.action-footer .action-hint { padding-left: 1rem; }
.action-header.active .hint-arrow {
    top: 3.5rem;
    
}
.grey-but.button.is-light { background-color: #e2e2e2; }
.button-row { margin-bottom: 0.75rem; text-align: right; }
.levelmodalmenu { padding:2rem 1.5rem 3rem ; }
.on-right { margin-left: auto; }
.competitorscroll {
    overflow: auto;
    height: calc(100vh - 16rem);
}
.edit-bar { z-index: 32; }
.allow-reg { padding: 2rem 0; }
.help-dot { 
    background-color: #ccc;
    border-radius: 100%;
    /* padding: 0.75em; */
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2rem;
    height: 2rem;
    /* font-size: 14px; */
    color: #fff;
    /* margin: 0 0 0 0.5rem; */
    margin-left: auto;
 }
@media (min-width: 512px ){
    .filter-label { display: inline; }
    .action-bar.filter-bar { 
        display: flex; padding:1rem;
        align-items: center;    left: 0;    position: fixed;
        right: 0;    z-index: 30; 
        transition: all 0.5s;
    }
    .help-dot { margin-left: 1rem; }
    .help-modal { max-width: 30rem; }
}
@media (min-width: 768px ){
    .newcompetitorscroll.is-step-0 {height: calc(100vh - 15rem);}
    .newcompetitorscroll.is-step-1 {height: calc(100vh - 11rem);}
}
@media (min-width: 1000px ){

}
</style>

<script>
import debounce from 'lodash/debounce'
import axios from "axios";
import RadioMenu from '../RadioMenu.vue'
import ZeroPad from './ZeroPad.vue'

//import { mapGetters, mapActions } from 'vuex';
export default {
    data: function() {
        return {
            clubs: [],
            isFetchingClubs: false,
            newcompetitors: [],
            selectednewcompetitors: [],
            selectedcompetitors: [],
            errors: [],
            step: 0,
            clubactive: false,
            clubplaceholder: 'Select a Club...',
            selectedclub: null,
            textvalid: false,
            chosenlevel: null,
            levelModalActive: false,
            hideheaderhint: false,
            hidefooterhint: false,
            mode: 0,
            clubFilterActive: false,
            levelFilterActive: false,
            selectedfilterclubs: 0,
            selectedfilterlevels: 0,
            editCompetitorModalActive: false,
            helpregactive: false
        }
    },
    computed: {
        stepvalid() {
            let valid = false;
            switch(this.step) {
                case 0 :
                    //valid = this.newcompetitors.length
                    valid = this.textvalid
                break;
                case 1 :
                    valid = this.newcompetitors.length && this.newcompetitors.every(x=> {
                        return x.classification && x.ageClassification 
                    })
            }
            return valid
        },
        filteredcompetitors() {
            let 
            result = [], 
            c = this.competition.competitors, 
            fclub = this.selectedfilterclubs, //.map(o => { return o.value }),
            flevel = this.selectedfilterlevels //.map(o => { return o.value })

            if(fclub == 0 && flevel == 0)
                return c.slice(0)
            

            result = c.filter(x => {
                return (x.competitor.club ? fclub == x.competitor.club.id : false || !fclub) && (flevel.age ? (flevel.age.id == x.ageClassificationId && flevel.class.id == x.classificationId) : true)
            })

            return result
        },
        usestepheader() {
            return this.step > 0
        },
        clubfilterlabel() {
            if(this.selectedfilterclubs==0) return 'All Clubs'
            return this.clubsfilter.filter(x=> this.selectedfilterclubs == x.value)[0].label
        },
        clubsfilter() {
            let c = this.competition.competitors, clubs = [], chk = []
            c.forEach(x => {
                if(x.competitor.club)
                    if(!chk.includes(x.competitor.club.id)) {
                        clubs.push({ value: x.competitor.club.id, label: x.competitor.club.name})
                        chk.push(x.competitor.club.id)
                    }
            })
            return clubs.sort((a, b) => {
                return a.label < b.label ? -1 : a.label > b.label ? 1 : 0
            }) 
        },
        levelsandages( ) {
            let comp = this.competition, chk = [], combos = []
            comp.rounds.forEach(r => {
                r.ageClassifications.forEach(ac => {
                    let c = ac.classification, a=ac.ageClassification,
                    k = c.id + ':' + a.id
                    if(!chk.includes(k))
                    {
                        chk.push(k)
                        combos.push({ key: k, value: {age: a, class:c }, label: c.name + ' - ' + a.name})
                    }
                })
            })
            return combos.sort((a, b) => {
                return a.label < b.label ? -1 : a.label > b.label ? 1 : 0
            }) 
        },
        clubneeded() { // TODO:  put requirement for a club into some structured data
            return this.competition && this.competition.competitionTypeTemplateId == 1
        }
    },
    components: {
        RadioMenu, ZeroPad
        //PTabs, PTabItem
    },
    props: {
        competition: Object
    },
    watch: {
        step(nv, ov) {
            //if (this.selectednewcompetitors.length!==this.newcompetitors.length && ov===0 && nv ===1)
            //    this.checkallnewcompetitors()
            if(nv===0&ov===1)
                this.hideheaderhint=true;
            if(this.step===1)
                this.clubactive=true;

            this.$store.dispatch('setshownavs', nv===0)
        }
    },
    methods: {
        nextstep(n) {
            if(n < 0 || (n > 0)&&this.stepvalid)
            this.step+=n;
        },
        validatetext() {
            let t = this.$refs.textarea
            if(!t) {this.textvalid = false
                return
            }
            let v = new RegExp(/[a-z]+[ ]+[a-z]+/gi)
            this.textvalid = v.test(t.value)
            return
        },
        parsetext() {
            let v = this.$refs.textarea.value, names = v.split(/[^a-zA-Z'. -]+/g).reverse()
            //this.$nextTick(() => ob.target.value = '')

            names.filter(x=>x.length > 4).forEach(n => { 
                this.newcompetitors.unshift({
                    competitor: { name:n, club:this.selectedclub, clubId:this.selectedclub?this.selectedclub.id:null },
                    ageClassificationId: null,
                    ageClassification: null,
                    classification: null,
                    classificationId: null,
                    competitionId: this.competition.id
                }) 
            });
            this.newcompetitors = [... new Set(this.newcompetitors)]//.sort()
            this.nextstep(1)
        },
        checkallnewcompetitors() {
            this.selectednewcompetitors = this.newcompetitors.slice(0)
        },
        checknonenewcompetitors() {
            this.selectednewcompetitors = [] 

        },
        resetfilters() {
            this.selectedfilterclubs = 0
            this.selectedfilterlevels = 0
        },
        addcompetitors() {
            if(this.stepvalid) {
                axios.post('/api/competitions/'+this.competition.id+'/competitors/',
                    this.newcompetitors
                ).then(res => {
                    if (res.error) {
                        this.errors.push(res.error);
                    } else {
                        // redirect to a new URL, or do something on success
                        this.$store.dispatch('backend/get_user_competition', this.competition.id)
                        this.reset()
                    }
                }).catch(e => { this.errors.push(e) })
            }
        },
        deletecompetitors() {
            console.log('Not implemented')
        },
        editcompetitors(){
            console.log('Not implemented')
        },
        reset() {
            this.selectednewcompetitors = []
            this.newcompetitors = []
            this.step=0
            this.clubactive = false
            this.mode = 0
            this.validatetext()
        },
        setcompetitors() {
            let n = this.chosenlevel
            let age = n.age, cla = n.class
            this.selectednewcompetitors.forEach(nc => {
                nc.ageClassification = age
                nc.ageClassificationId = age.id
                nc.classification = cla
                nc.classificationId = cla.id
            })
            this.hideheaderhint=true;
            this.levelModalActive=false;
            this.checknonenewcompetitors()
            this.chosenlevel = null
        },
        setselectedclub(c) {
            this.selectedclub = c;
            this.clubactive = c && true;
            this.$nextTick(() => this.$refs.textarea.focus())
        },
        deletenewcompetitors() {
            let sel = this.selectednewcompetitors
            this.newcompetitors = this.newcompetitors.filter(el => !sel.includes(el))
            if(this.newcompetitors.length===0)
                this.reset();
        },
        filterbyclub() {
            setTimeout(() => this.clubFilterActive = false, 200)
        },
        filterbylevel() {
            setTimeout(() => this.levelFilterActive = false, 200)
        },
        getAsyncClubs: debounce(function (q) {
                if (!q.length) {
                    this.data = []
                    return
                }
                this.isFetchingClubs = true
                axios.get(`/api/clubs?q=${q}`)
                    .then(({ data }) => {
                        this.clubs = []
                        data.forEach((item) => this.clubs.push(item))
                    })
                    .catch((error) => {
                        this.clubs = []
                        throw error
                    })
                    .finally(() => {
                        this.isFetchingClubs = false
                    })
            }, 500)
    },
}
</script>

